import { AlertColor } from '@mui/material';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CommonState {
  loading: boolean;
  ui: {
    dialog: {
      [name: string]: boolean;
    };
    dialogState: any;
  };
  snackbar: {
    message: string;
    type: AlertColor;
    open: boolean;
  };
  sidebar: {
    open: boolean;
  };
}

const initialState: CommonState = {
  loading: false,
  ui: { dialog: {}, dialogState: undefined },
  snackbar: {
    message: '',
    type: 'info',
    open: false,
  },
  sidebar: {
    open: false,
  },
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    toggleModals: (
      state,
      action: PayloadAction<{
        name: string;
        data?: any;
      }>,
    ) => {
      state.ui.dialog = {
        ...state.ui.dialog,
        [action.payload.name]: !state.ui.dialog[action.payload.name],
      };
      state.ui.dialogState = action.payload.data || null;
    },
    closeModals: (state, action: PayloadAction<string>) => {
      state.ui.dialog = { ...state.ui.dialog, [action.payload]: false };
    },
    showNotification: (
      state,
      action: PayloadAction<{
        message: string;
        type?: AlertColor;
      }>,
    ) => {
      state.snackbar = { open: true, message: action.payload.message, type: action.payload.type || 'info' };
    },
    hideNotification: (state) => {
      state.snackbar = { ...state.snackbar, open: false };
    },
    toggleSidebar: (state) => {
      state.sidebar = { ...state.sidebar, open: !state.sidebar.open };
    },
  },
});

export const { setLoading, toggleModals, closeModals, showNotification, hideNotification, toggleSidebar } = commonSlice.actions;

export default commonSlice.reducer;
